import { Environment } from '../types';

export const environment: Environment = {
  isProduction: false,
  mtbeEndpoint: 'https://api.staging.qualio.com',
  complianceEndpoint: 'https://api.compliance.staging.qualio.com',
  name: 'staging',
  loginUrl: `https://${window.location.host}/`,
  authSuccessRefreshIntervalMillis: 60000,
  mtfeEndpoint: `https://${window.location.host}`,
  ldClientSideId: '61e6a31060139c1610d1516b',
  devPortal: 'https://developer-portal.staging.qualio.com',
};
